import { DownloadItemTypeEnum } from "../../enums/DownloadItemTypeEnum";
import { ProductGroupedDownloadItemInterface } from "../../interfaces/apiV2/product/ProductDownloadsInterface";

export interface ProductDownloadFile {
    name: string;
    type: string;
    url: string;
    extension?: string | null;
}

export interface ProductDownloadEntry {
    key: string;
    label: string;
    files: ProductDownloadFile[];
}

export const buildProductDownloadEntries = (
    downloads: Record<string, ProductGroupedDownloadItemInterface[]>,
): ProductDownloadEntry[] =>
    Object.entries(downloads)
        .filter(([key]) => key !== "all")
        .map(([key, items]) => {
            const files: ProductDownloadFile[] = [];

            items.forEach((group) => {
                if (!Array.isArray(group.value)) {
                    return;
                }

                group.value.forEach((file) => {
                    files.push({
                        name: file.label,
                        type: key,
                        url: file.url ?? "",
                        extension: file.extension,
                    });
                });
            });

            return {
                key,
                label: items[0]?.label ?? "",
                files,
            };
        })
        .filter((entry) => entry.files.length > 0);

export const hasProductDownloadContent = (
    downloads: Record<string, ProductGroupedDownloadItemInterface[]>,
): boolean => buildProductDownloadEntries(downloads).length > 0;

export const formatDownloadFileName = (name: string, type: string): string => {
    if (type !== DownloadItemTypeEnum.images) {
        return name;
    }

    const stripped = name.replace(/^[^_]*_/, "");
    return stripped.charAt(0).toUpperCase() + stripped.slice(1);
};
